module.exports = __webpack_public_path__ + "static/media/dayBackground.02adbac8.jpg";